import { ResultCodeEnum } from "./SuperEnum";
import Tools from "./Tools";

/**
 * HTTP返回值
 */
export default class HttpResponse<T = any> {
     code?: ResultCodeEnum;
     data?: T;
     msg?: string;
     /**
      * 检查是否成功
      * @param showErrorMessage
      */
     public CheckIsOk(showErrorMessage: boolean = true): boolean {
          if (this.code == ResultCodeEnum.Success) {
               return true;
          }
          else {
               if (showErrorMessage) {
                    if (Tools.IsNotNull(this.msg))
                         Tools.AlertError(this.msg!);
               }
               return false;
          }
     }
}